import React from "react";
import {PatternBackground} from "../../components/PatternBackground";
import UsersTable from "./UsersTable";

export const UsersPage = () => {
  return (
      <div className="">
        <PatternBackground>
          <p className="lead fw-bold">User Management</p>
          <small>Create and view  all users</small>
        </PatternBackground>
          <div className="om-container">
            <div className='p-4 shadow-sm bg-white rounded'>
          <div className='mt-5'>
            <UsersTable />
          </div>
        </div>
          </div>
      </div>
  )
}